exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".appointment-dialog .product-info-dialog-content{font-size:14px;margin-top:0px !important}.appointment-dialog .MuiPaper-rounded{border-radius:10px;padding:1.5rem}.appointment-dialog .product-info-close-button{top:1.9rem;right:1.5rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/Quoters/Medicare/Helpers/AppointmentDialog.scss
// module id = 7839
// module chunks = 13